import React from "react";
import strings from "../constants/strings.json";
import { Link } from "react-router-dom";

interface FooterProps {
    locale?: string;
}

export default function Footer({ locale = "en" }: FooterProps) {
    // Fallback to English if locale not found
    // Using any type here to bypass strict typing on the JSON structure for simplicity
    const localeStrings = (strings as any)[locale] ?? (strings as any)["en"];
    const footer = localeStrings.footer;

    // Replace {year} placeholder in localized copyright
    const copyrightText = footer.copyright.replace(
        "{year}",
        new Date().getFullYear().toString()
    );

    return (
        <footer className="bg-gradient-to-r from-[#174143] to-[#1f5961] text-white">
            <div className="border-t border-white/10">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        {/* Dynamic Copyright */}
                        <p className="text-sm text-white/80 font-medium text-center md:text-left">{copyrightText}</p>

                        {/* Legal Links */}
                        <div className="flex items-center gap-6">
                            <Link to="/privacy-policy" className="text-sm text-white/80 hover:text-white transition-colors">
                                {footer.privacy_policy || "Privacy Policy"}
                            </Link>
                            <Link to="/terms-and-conditions" className="text-sm text-white/80 hover:text-white transition-colors">
                                {footer.terms_conditions || "Terms & Conditions"}
                            </Link>
                        </div>

                        {/* Developed by Section */}
                        <p className="text-sm text-white/70 flex items-center gap-2">
                            {footer.developed_by_part1}
                            <a
                                href={footer.developed_by_url || "https://binaryflow.in/"}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white font-semibold hover:text-[#3d9ea4] transition-colors duration-300 inline-flex items-center gap-1"
                            >
                                {footer.developed_by_part2}
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}